/*
 * @Description:
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  请选择部门和用户: 'Please select a department and a user',
  请选择日期: 'Please select a date',
  数据概览: 'Data Overview',
  线索总数: 'Total Clue Count',
  环比: 'MoM Comparison',
  动态记录数: 'Follow-Up Record Count',
  超: 'Exceed',
  个: 'Count',
  元: 'Yuan',
  待处理: 'Pending',
  外呼接通数: 'Outbound Connection Count',
  日程数: 'Number of Schedules',
  商机数: 'Business Opportunity Count',
  线索及时跟进率: 'Clue Timely Follow-up Rate',
  分配线索数: 'Assigned Clue Count',
  '40分钟内跟进线索数': 'Follow-up Clue Count within 40 Minutes',
  状态分布: 'Status Distribution',
  建议转化: 'Suggested Conversion',
  建议无效: 'Suggested Invalid',
  待定: 'Undetermined',
  点击: 'Click',
  待跟进线索: 'Pending Clue Follow-Up',
  数据加载中: 'Loading Data',
  跟进人: 'Follow-up Person',
  时间: 'Time',
  总数: 'Total Count',
  获取数据失败: 'Failed to Fetch Data',
  日程安排: 'Schedule Arrangement',
  线索已删除: 'Clue Deleted',
  创建人: 'Creator',
  抱歉: 'Sorry',
  已删除: 'Data is Deleted, Unable to view details',
  周日: 'Sun',
  周一: 'Mon',
  周二: 'Tue',
  周三: 'Wed',
  周四: 'Thu',
  周五: 'Fri',
  周六: 'Sat',
  日: 'Day',
  业绩概览参数: 'Performance overview parameters',
  实时概况参数: 'Real-time profile parameters',
  过程结果: 'Process Result',
  数据结果: 'Data Result',
  选中所有: 'Select All',
  数据指标: 'Data Indicator',
  实时概况: 'Real-time Overview',
  订单产品金额: 'Order Product Amount',
  商机漏斗: 'Opportunity Funnel',
  商机总数: 'Total Opportunities',
  商机总额: 'Total Opportunity Amount',
  线索转化: 'Lead Conversion',
  指标名称: 'Indicator Name',
  业绩概览: 'Performance Overview',
  转化率: 'Conversion Rate',
  转化为客户的线索: 'Leads Converted to Customers',
  转化为商机的线索: 'Leads Converted to Opportunities',
  转化为订单的线索: 'Leads Converted to Orders',
  '转化率计算规则：N%=（当前指标数/总的线索数）*100%': 'Conversion Rate Calculation Rule: N% = (Current Indicator Number /Total Number of Leads)*100%'
};
